import { render, staticRenderFns } from "./AchievementTable.vue?vue&type=template&id=4c130821&"
import script from "./AchievementTable.vue?vue&type=script&lang=js&"
export * from "./AchievementTable.vue?vue&type=script&lang=js&"
import style0 from "./AchievementTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports